import { EnBookmarkType, EnNotificationType } from '@prisma/client'
import { ReadonlyURLSearchParams } from 'next/navigation'
import { EnBookTab } from 'src/enums/book-tab.enum'

export const getNotificationType = (
  paramTab?: string | null,
): EnNotificationType => {
  switch (paramTab) {
    case 'social':
      return EnNotificationType.SOCIAL

    case 'important':
      return EnNotificationType.IMPORTANT

    case 'book':
    default:
      return EnNotificationType.BOOK
  }
}

export const getBoomarkType = (paramTab?: string | null): EnBookmarkType => {
  switch (paramTab) {
    case 'completed':
      return EnBookmarkType.COMPLETED

    case 'plan':
      return EnBookmarkType.PLAN

    case 'important':
      return EnBookmarkType.ABANDONED

    case 'favorite':
      return EnBookmarkType.FAVORITE

    case 'read':
    default:
      return EnBookmarkType.READ
  }
}

export const getActiveTab = (searchParams: ReadonlyURLSearchParams | null) => {
  if (!searchParams) {
    return EnBookTab.INFO
  }

  switch (searchParams.get('tab')) {
    case 'chapters': {
      return EnBookTab.CHAPTERS
    }

    case 'comments': {
      return EnBookTab.COMMENTS
    }

    default: {
      return EnBookTab.INFO
    }
  }
}
